import React, { useState } from "react";
import { Layout, Typography, Card, Row, Col, Button, Pagination, Tag, Tabs } from "antd";
import { CloudOutlined, DatabaseOutlined } from "@ant-design/icons";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { TabPane } = Tabs;

const migrations = [
    { id: 1, title: "Lift and Shift Migration", category: "Cloud Migrations", difficulty: "Beginner", description: "Move your workloads to the cloud without redesigning them.", takenBy: 120 },
    { id: 2, title: "Replatforming", category: "Cloud Migrations", difficulty: "Intermediate", description: "Modify your applications for the cloud environment without a complete redesign.", takenBy: 150 },
    { id: 3, title: "Refactoring", category: "Cloud Migrations", difficulty: "Advanced", description: "Re-architect applications to fully leverage cloud-native features.", takenBy: 80 },
    { id: 4, title: "Hybrid Cloud Strategy", category: "Cloud Migrations", difficulty: "Intermediate", description: "Integrate on-premise and cloud systems for a hybrid solution.", takenBy: 100 },
    { id: 5, title: "Cloud-to-Cloud Migration", category: "Cloud Migrations", difficulty: "Intermediate", description: "Migrate your data and applications from one cloud provider to another.", takenBy: 110 },
    { id: 6, title: "Disaster Recovery as a Service", category: "Cloud Migrations", difficulty: "Advanced", description: "Ensure business continuity with cloud-based disaster recovery solutions.", takenBy: 95 },
    { id: 7, title: "Data Migration to Cloud", category: "Cloud Migrations", difficulty: "Beginner", description: "Move your data to the cloud for better scalability and management.", takenBy: 180 },
    { id: 8, title: "Cloud-Native Application Migration", category: "Cloud Migrations", difficulty: "Advanced", description: "Redesign your applications for a cloud-first approach.", takenBy: 70 },
];

const pageSize = 4;

function CloudMigrations() {
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("Beginner");

    const filteredMigrations = migrations.filter(migration => migration.difficulty === activeTab);
    const paginatedMigrations = filteredMigrations.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <Layout>
            <Content style={{ padding: "50px" }}>
                <Title level={2}>Cloud Migrations</Title>
                <Paragraph>Seamlessly migrate your workloads, data, and applications to the cloud with efficient migration strategies tailored for your needs.</Paragraph>

                <Tabs activeKey={activeTab} onChange={key => { setActiveTab(key); setCurrentPage(1); }} centered>
                    <TabPane tab="Beginner" key="Beginner" />
                    <TabPane tab="Intermediate" key="Intermediate" />
                    <TabPane tab="Advanced" key="Advanced" />
                </Tabs>

                <Row gutter={[16, 16]}>
                    {paginatedMigrations.map((migration) => (
                        <Col xs={24} sm={12} md={6} key={migration.id}>
                            <Card hoverable>
                                <Title level={5}>{migration.title}</Title>
                                <Tag color="blue">{migration.category}</Tag>
                                <Tag color={migration.difficulty === "Beginner" ? "green" : migration.difficulty === "Intermediate" ? "gold" : "red"}>
                                    {migration.difficulty}
                                </Tag>
                                <Paragraph>{migration.description}</Paragraph>
                                <Paragraph><DatabaseOutlined /> {migration.takenBy} migrations performed</Paragraph>
                                <Button type="primary">Start Migration</Button>
                            </Card>
                        </Col>
                    ))}
                </Row>

                <Pagination
                    current={currentPage}
                    total={filteredMigrations.length}
                    pageSize={pageSize}
                    onChange={setCurrentPage}
                    style={{ marginTop: "20px", textAlign: "center" }}
                />
            </Content>
        </Layout>
    );
}

export default CloudMigrations;
